import { ApprovalsMenuItem } from '@core/models/menu-item.model';

export const approvalsMenu : ApprovalsMenuItem[] = [
    {
        title: 'Outstanding',
        link: '/approvals/outstanding',
        disabled: false,
        feedbacks_status: 'uncompleted'
    },
    {
        title: 'Completed',
        link: '/approvals/completed',
        disabled: false,
        feedbacks_status: 'completed'
    }
];
